import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import Section from '@segment/matcha/recipes/Section'

import Testimonial from '@segment/templates/Testimonial'

const copy = {
  text: `“Any experienced security practitioner can tell you that technology and processes are just two key components of an effective security program. People are the third component. At Segment, security is everyone’s responsibility.”`,
  name: `Coleen Coolidge`,
  position: `CISO at Twilio Segment`,
}

const TestimonialBox: FC<PropsWithChildren<unknown>> = () => {
  return (
    <Wrapper>
      <StyledSection variant="noCopy">
        <Testimonial text={copy.text} name={copy.name} position={copy.position} />
      </StyledSection>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.twilio.gray[10]};
`

const StyledSection = styled(Section)`
  max-width: 1060px;
`

export default TestimonialBox
